module.exports = __webpack_public_path__ + "static/img/e6.30e2ec2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/hot/e6.png
// module id = Kl5/
// module chunks = 0